import { GET_MAP_POSITIONS, GET_MAP_POSITIONS_SUCCESS, GET_MAP_POSITIONS_ERROR } from "./actionTypes";

const initialState = {
  errorGetMapPositions: "",
  loadingGetMapPositions: false,
  map_positions: null,
  successGetMapPositions: "",
};

const getMapPositions = (state = initialState, action) => {
  switch (action.type) {
    case GET_MAP_POSITIONS:
      state = {
        ...state,
        loadingGetMapPositions: true,
      };
      break;
    case GET_MAP_POSITIONS_SUCCESS:
      state = {
        ...state,
        loadingGetMapPositions: false,
        map_positions: action.payload.map_positions,
        successGetMapPositions: action.payload.message,
      };
      break;
    case GET_MAP_POSITIONS_ERROR:
      state = { ...state, errorGetMapPositions: action.payload, loadingGetMapPositions: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getMapPositions;
